import { render, staticRenderFns } from "./CreateShippingLabel.vue?vue&type=template&id=4fa180a1&scoped=true&"
import script from "./CreateShippingLabel.vue?vue&type=script&lang=js&"
export * from "./CreateShippingLabel.vue?vue&type=script&lang=js&"
import style0 from "./CreateShippingLabel.vue?vue&type=style&index=0&id=4fa180a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa180a1",
  null
  
)

export default component.exports